import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './TopZoneManagement.module.css';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';
import { useToast } from '../../../hooks/useToast';

// Components
import InputSelect from '../../UI/InputSelect/InputSelect';
import CircleSelector from '../../UI/CircleSelector/CircleSelector';

// Interfaces
import { Hospital } from '../../../interfaces/Hospital';
import { Profile } from '../../../interfaces/Profile';
import { OptionsSelect } from '../../../interfaces/Input';
interface Props {
    disableAssociation: boolean
    profile: Profile | null
    setProfile: React.Dispatch<React.SetStateAction<Profile | null>>
}

const TopZoneManagement: React.FC<Props> = ({ disableAssociation, profile, setProfile }) => {

    const { t } = useTranslation();

    const toast = useToast();

    const { sendRequest: getHospitals } = useHttp<Hospital[]>();
    const { sendRequest: updateProfile } = useHttp();

    const [hospitals, setHospitals] = useState<Hospital[]>([]);
    const [currentHospitalID, setCurrentHospitalID] = useState<Hospital['id'] | null>(null);

    useEffect(() => {
        getHospitals({
            url: getEnvironmentApiUrl() + 'hospital/profiles',
            method: 'POST',
            body: { filter: {}, params: {} }
        }, (data) => {
            if (data.length === 1) setCurrentHospitalID(data[0].id);
            setHospitals(data);
        });
    }, [getHospitals]);

    const handleChangeHospital = (option: OptionsSelect) => {
        setCurrentHospitalID(Number(option.id));
        setProfile(null);
    };

    const handleChangeProfile = (option: OptionsSelect) => setProfile(currentProfiles.find(p => p.id === option.id) || null);

    const handleChangeZoneByBed = (val: boolean) => {
        if (disableAssociation === true) {
            toast.warning(t('delete_zones_first'));
            return;
        }
        if (profile) updateProfile({
            url: getEnvironmentApiUrl() + 'profile/' + profile.id,
            method: 'PUT',
            body: { zone_by_bed: val }
        }, () => {
            setHospitals(oldHospitals => oldHospitals.map(h => {
                if (h.id !== currentHospitalID) return h;
                const newProfiles = h.Profiles === undefined ? [] : [...h.Profiles];
                return {
                    ...h,
                    Profiles: newProfiles.map(p => {
                        if (p.id !== profile?.id) return p;
                        return { ...p, zone_by_bed: val };
                    })
                };
            }));
            setProfile(oldProfile => oldProfile === null ? null : ({ ...oldProfile, zone_by_bed: val }));
        });
    };

    const currentHospital = hospitals.find(h => h.id === currentHospitalID);
    const currentProfiles = currentHospital?.Profiles || [];
    const linkWithBed = profile?.zone_by_bed || false;


    return (
        <div className={styles.filterSelectors}>
            {hospitals.length !== 1 &&
                <div className={styles.hospitalInput}>
                    <InputSelect
                        options={hospitals.map(hospital => (
                            { id: hospital.id, name: hospital.name || '' }
                        ))}
                        label={t('select_hospital')}
                        value={currentHospital ? currentHospital.name || '' : ''}
                        onChange={handleChangeHospital}
                    />
                </div>
            }
            <div className={styles.departmentInput} style={{ display: currentHospital ? 'flex' : 'none' }}>
                <InputSelect
                    options={currentProfiles.map(profile => ({
                        id: profile.id, name: profile.name || ''
                    }))}
                    label={t('select_service')}
                    value={profile?.name || ''}
                    onChange={handleChangeProfile}
                />
            </div>
            {profile &&
                <div className={styles.selectorsContainer}>
                    <CircleSelector
                        text={t('link_zones_with_beds')}
                        active={linkWithBed}
                        handleClick={() => handleChangeZoneByBed(true)}
                    />
                    <CircleSelector
                        text={t('link_zones_with_towns')}
                        active={!linkWithBed}
                        handleClick={() => handleChangeZoneByBed(false)}
                    />
                </div>
            }
        </div>
    );
};

export default TopZoneManagement;